import { CloseOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Select, Radio } from "antd";
import { useEffect, useState } from "react";

const RepProductFilter = ({ current, onClose, periodType = [], employeeType = [], products = [], priceTypes = [], onRefresh }) => {
  const [item, setItem] = useState({
    startDate: null,
    endDate: null,
    productIds: [],
    employeeType: null,
    priceFilterType: null,
    ...current
  });
  const [form] = Form.useForm();

  useEffect(() => { 
    form.setFieldsValue(current);
  }, [current]);

  const onValuesChange = (value) => {
    const updatedItem = {...item, ...value};
    setItem(updatedItem);
  }

  const onSave = () => {
    onRefresh();
    onClose(item);
  }

  const customTagRender = (props) => {
    return <span className="filters-tag-label">{props.label}</span>;
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
          <div className="sport-modal-title">
            <span>Параметры отчета</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose()}/>
          </div>
          <Form form={form} onValuesChange={onValuesChange} layout="inline" colon={false}>
            <Form.Item name="startDate" label=" Период с">
              <DatePicker format="DD.MM.YYYY"/>
            </Form.Item>
            <Form.Item name="endDate" label="по">
              <DatePicker format="DD.MM.YYYY"/>
            </Form.Item>
            <Form.Item name="productIds" label="Товары">
              <Select
                allowClear={false}
                mode="multiple"
                options={products.map(product => ({ value: product.id, label: product.name }))}
                className="filters-select"
                placeholder="Все"
                maxTagCount={2}
                tagRender={customTagRender}
              />
            </Form.Item>
            <Form.Item name="employeeType" label="Сотрудники">
              <Select
                allowClear={false}
                options={employeeType}
                className="filters-select"
                placeholder="Все сотрудники"
                tagRender={customTagRender}
              />
            </Form.Item>
            <Form.Item name="priceFilterType">
                <Radio.Group options={priceTypes} optionType="button" buttonStyle="solid" />
            </Form.Item>
            <Form.Item>
              <Button className="sport-btn" onClick={onSave}>ОК</Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default RepProductFilter;
